import './slick.js'

const $ = window.jQuery

$(document).ready(() => {
    document.querySelectorAll('.wp-block-sfat-slider').forEach(container => {
        const config = container.getAttribute('data-options')
        $(container.querySelector('.slider')).slick(JSON.parse(config))
    })
})
